export default __webpack_public_path__ + "static/media/white_king.bb28c4fc.png";